var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19496 0C9.18466 0 9.17442 3.63827e-05 9.16414 8.9474e-05L9.12207 3.47611C9.13169 3.476 9.14132 3.47592 9.15096 3.47592C11.4389 3.47592 13.2136 5.27988 17.0708 11.7771L17.306 12.1726L17.3214 12.1985L19.4806 8.95875L19.4656 8.93372C18.9575 8.10725 18.4693 7.34684 18.0011 6.65251C17.4581 5.848 16.9389 5.1293 16.4349 4.48763C13.8832 1.23868 11.7487 0 9.19496 0Z",
    fill: "url(#paint0_linear_10167_18833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16362 8.94739e-05C6.59747 0.0132916 4.32883 1.67266 2.69065 4.21186C2.68585 4.21928 2.68105 4.22673 2.67627 4.23419L5.68331 5.87088C5.68819 5.86348 5.69308 5.85608 5.69799 5.8487C6.65458 4.40842 7.84503 3.48979 9.12155 3.47611C9.13117 3.476 9.1408 3.47592 9.15044 3.47592L9.19444 0C9.18414 0 9.1739 3.63827e-05 9.16362 8.94739e-05Z",
    fill: "url(#paint1_linear_10167_18833)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69197 4.21484C2.68719 4.22227 2.68239 4.22971 2.67759 4.23718C1.60113 5.91285 0.798668 7.96914 0.364991 10.1875C0.363113 10.1971 0.361241 10.2067 0.359375 10.2163L3.73766 11.0134C3.73943 11.0038 3.74121 10.9941 3.74299 10.9845C4.10409 9.03496 4.79157 7.22683 5.68463 5.87387C5.68949 5.86647 5.6944 5.85907 5.69931 5.85168L2.69197 4.21484Z",
    fill: "url(#paint2_linear_10167_18833)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74296 10.9845L0.36495 10.1875C0.363072 10.1971 0.3612 10.2067 0.359334 10.2163C0.122856 11.4363 0.00254867 12.676 2.43993e-05 13.9187C4.51656e-06 13.9287 -3.09978e-06 13.9388 1.1306e-06 13.9488L3.46458 14.2588C3.46431 14.2487 3.46401 14.2387 3.46378 14.2286C3.46206 14.1565 3.4612 14.0835 3.46118 14.0094C3.46291 13.0045 3.55543 12.0017 3.73763 11.0134C3.73939 11.0038 3.74116 10.9942 3.74296 10.9845Z",
    fill: "url(#paint3_linear_10167_18833)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56994 15.3351C3.50779 14.9779 3.47258 14.6166 3.46458 14.2541C3.46431 14.2441 3.46401 14.2341 3.46378 14.224L2.43993e-05 13.9141C4.51656e-06 13.9241 -3.09978e-06 13.9342 1.1306e-06 13.9442C1.1306e-06 14.7176 0.0644979 15.4437 0.189846 16.1127C0.191659 16.1223 0.193442 16.1318 0.19528 16.1415L3.57518 15.364C3.57341 15.3544 3.57167 15.3447 3.56994 15.3351Z",
    fill: "url(#paint4_linear_10167_18833)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35888 17.1291C3.98188 16.7176 3.71508 16.124 3.5748 15.3649C3.57302 15.3553 3.57131 15.3456 3.56957 15.3359L0.189453 16.1135C0.191264 16.1232 0.193047 16.1327 0.194887 16.1424C0.450368 17.4837 0.951412 18.6016 1.66895 19.4474C1.67533 19.4549 1.68173 19.4624 1.68816 19.4699L4.37903 17.1508C4.37231 17.1436 4.36554 17.1364 4.35888 17.1291Z",
    fill: "url(#paint5_linear_10167_18833)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3732 7.51172C12.3364 10.6359 11.1025 12.5955 11.1025 12.5955C8.38917 16.8487 7.45052 17.802 5.93989 17.802C5.30954 17.802 4.78295 17.5776 4.37952 17.1485C4.37279 17.1414 4.36604 17.1341 4.35938 17.1269L1.66943 19.4451C1.67581 19.4526 1.68222 19.4602 1.68864 19.4677C2.67939 20.6225 4.07785 21.2634 5.8079 21.2634C8.42535 21.2634 10.3078 20.0293 13.6544 14.1795C13.6544 14.1795 15.0494 11.7159 16.0091 10.0189C15.4147 9.05911 14.8737 8.22818 14.3732 7.51172Z",
    fill: "#0082FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0024 2.58594C17.9956 2.59323 17.9886 2.60068 17.9817 2.608C17.4468 3.17787 16.9335 3.81429 16.4341 4.48952C16.938 5.13121 17.4583 5.8513 18.0012 6.6558C18.6412 5.66804 19.2386 4.86806 19.8241 4.25489C19.831 4.24763 19.8378 4.24057 19.8448 4.23333L18.0024 2.58594Z",
    fill: "url(#paint6_linear_10167_18833)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8933 2.27713C26.4728 0.842048 24.7791 0 22.9685 0C21.0591 0 19.4532 1.04628 18.0046 2.58339C17.9977 2.59067 17.9907 2.59811 17.9839 2.60543L19.8263 4.25232C19.8332 4.24506 19.84 4.238 19.847 4.23079C20.8012 3.23819 21.7248 2.7426 22.7485 2.7426C23.8506 2.7426 24.8819 3.26131 25.7752 4.17065C25.7821 4.17778 25.7891 4.18485 25.7961 4.19202L27.9145 2.2985C27.9075 2.29133 27.9003 2.28426 27.8933 2.27713Z",
    fill: "#0082FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.999 13.4584C31.9195 8.85061 30.3071 4.73132 27.9137 2.29871C27.9065 2.29154 27.8995 2.28447 27.8924 2.27734L25.7744 4.17086C25.7814 4.17799 25.7884 4.18505 25.7954 4.19223C27.5958 6.04173 28.8309 9.48185 28.9432 13.4574C28.9434 13.4674 28.9436 13.4774 28.944 13.4874L31.9994 13.4884C31.9994 13.4784 31.9992 13.4684 31.999 13.4584Z",
    fill: "url(#paint7_linear_10167_18833)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9968 13.4919C31.9968 13.4819 31.9966 13.4719 31.9964 13.4619L28.9406 13.4609C28.9408 13.4709 28.941 13.4809 28.9414 13.491C28.9463 13.6776 28.9488 13.8653 28.9488 14.0541C28.9488 15.1381 28.787 16.0142 28.4577 16.6468C28.4528 16.6562 28.4477 16.6656 28.4429 16.6749L30.7211 19.0445C30.7269 19.0359 30.7324 19.0273 30.7381 19.0187C31.5651 17.7424 31.9994 15.9694 31.9994 13.8195C31.9994 13.71 31.9985 13.6008 31.9968 13.4919Z",
    fill: "url(#paint8_linear_10167_18833)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4582 16.6406C28.4534 16.65 28.4483 16.6594 28.4434 16.6687C28.1585 17.2019 27.7518 17.5576 27.2202 17.7131L28.2588 20.9864C28.3963 20.9397 28.5302 20.8873 28.6604 20.8291C28.6994 20.8118 28.7381 20.7939 28.7764 20.7756C28.7984 20.765 28.8204 20.7543 28.8421 20.7434C29.5289 20.4011 30.1094 19.8963 30.5787 19.2458C30.6075 19.2061 30.6358 19.166 30.6635 19.1253C30.6832 19.0965 30.7027 19.0675 30.7217 19.0383C30.7274 19.0297 30.7329 19.0211 30.7386 19.0125L28.4582 16.6406Z",
    fill: "url(#paint9_linear_10167_18833)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5598 17.8034C26.2117 17.8034 25.9043 17.7516 25.6036 17.6172L24.54 20.9684C25.1378 21.1726 25.7755 21.2646 26.4866 21.2646C27.1417 21.2646 27.7431 21.1667 28.2884 20.9776L27.25 17.7054C27.0262 17.7725 26.7936 17.8055 26.5598 17.8034Z",
    fill: "url(#paint10_linear_10167_18833)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4328 16.6556C24.4262 16.6481 24.4197 16.6405 24.4129 16.6328L21.9658 19.1778C21.9728 19.1851 21.9796 19.1924 21.9863 19.1997C22.8366 20.1059 23.6487 20.668 24.5694 20.9765L25.6321 17.6277C25.2442 17.461 24.8687 17.1589 24.4328 16.6556Z",
    fill: "url(#paint11_linear_10167_18833)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4123 16.6358C23.6784 15.7822 22.7703 14.361 21.3421 12.0629L19.4808 8.95862L19.4658 8.93359L17.3062 12.1725L17.3215 12.1984L18.6404 14.417C19.9188 16.5563 20.9602 18.1039 21.9653 19.1808C21.9722 19.1882 21.979 19.1955 21.9858 19.2027L24.432 16.6586C24.4254 16.6511 24.4189 16.6435 24.4123 16.6358Z",
    fill: "url(#paint12_linear_10167_18833)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10167_18833",
    x1: 18.0454,
    y1: 10.881,
    x2: 10.8766,
    y2: 1.48744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006,
    stopColor: "#0867DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4539,
    stopColor: "#0668E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10167_18833",
    x1: 4.08873,
    y1: 4.79592,
    x2: 9.00335,
    y2: 1.06478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1323,
    stopColor: "#0064DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10167_18833",
    x1: 2.00695,
    y1: 10.2742,
    x2: 3.97839,
    y2: 5.31151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0147,
    stopColor: "#0072EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6881,
    stopColor: "#0064DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10167_18833",
    x1: 1.73919,
    y1: 13.8594,
    x2: 1.9673,
    y2: 10.8285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731,
    stopColor: "#007CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    stopColor: "#0072EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10167_18833",
    x1: 1.86464,
    y1: 15.5011,
    x2: 1.70147,
    y2: 14.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731,
    stopColor: "#007FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10167_18833",
    x1: 1.76847,
    y1: 15.8209,
    x2: 2.78534,
    y2: 17.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0731,
    stopColor: "#007FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10167_18833",
    x1: 17.3969,
    y1: 5.38839,
    x2: 18.7412,
    y2: 3.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2799,
    stopColor: "#007FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10167_18833",
    x1: 27.6193,
    y1: 2.97633,
    x2: 30.4316,
    y2: 13.3218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "#0081FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10167_18833",
    x1: 31.1082,
    y1: 13.7212,
    x2: 29.3283,
    y2: 17.3179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0619,
    stopColor: "#0081FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10167_18833",
    x1: 27.9142,
    y1: 19.2185,
    x2: 29.578,
    y2: 18.0853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10167_18833",
    x1: 25.3059,
    y1: 19.4409,
    x2: 27.6179,
    y2: 19.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0377EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#0279F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10167_18833",
    x1: 23.2967,
    y1: 18.166,
    x2: 24.9588,
    y2: 19.1439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0019,
    stopColor: "#0471E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0377EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10167_18833",
    x1: 18.2259,
    y1: 10.9585,
    x2: 23.5504,
    y2: 17.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2765,
    stopColor: "#0867DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0471E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAdd);
export default __webpack_public_path__ + "static/media/facebook-add.cd0bf5996be9b067564d1d2cdcefb1a0.svg";
export { ForwardRef as ReactComponent };